
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { OperationInfo, User } from '@/types';
import LeadCategories from '@/components/LeadCategories.vue';
import LeadTags from '@/components/LeadTags.vue';
import LeadOpType from '@/components/LeadOpType.vue';
import LeadOpNotesIcon from '@/components/LeadOpNotesIcon.vue';
import { leadRouteCode } from '@/helpers/leadCode';

@Component({
  components: {
    LeadCategories,
    LeadTags,
    LeadOpType,
    LeadOpNotesIcon,
  },
})
export default class OperationLead extends Vue {
  @Prop(Object) readonly operationInfo: OperationInfo | undefined;

  opNotes: string | null = null

  get opNumber(): null | string {
    return this.operationInfo?.opNumber
      ? this.operationInfo.opNumber
      : 'Assente';
  }

  get operationInfoCode(): null | string {
    return this.operationInfo?.code
      ? this.operationInfo.code
      : '';
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get operationAllowedUsers(): number[] {
    if (!this.operationInfo?.allowedUsers) return [];
    const parsed = this.operationInfo.allowedUsers.substring(1, this.operationInfo.allowedUsers.length - 1).split(':')
      .map((s: string) => Number(s))
      .filter((n: number) => !Number.isNaN(n));
    return parsed;
  }

  get fatherAllowedUsers(): number[] {
    // Se non è disponibile fatherAllowedUsers, usa allowedUsers (retrocompatibilità)
    const allowedUsersString = this.operationInfo?.fatherAllowedUsers || this.operationInfo?.allowedUsers;
    return allowedUsersString?.substring(1, allowedUsersString.length - 1).split(':')
      .map((s: string) => Number(s)) || [];
  }

  get isCurrentUserAllowed(): boolean {
    // Controlla se l'utente è negli allowedUsers della lead padre (non solo della connessione)
    return this.fatherAllowedUsers.includes(this.user.id);
  }

  onEdit() {
    console.log('OperationLead: onEdit()'); // eslint-disable-line no-console

    this.$nextTick(() => {
      (this.$refs.tippyRef as any).tippy().hide();
    });

    this.$emit('edit');
  }

  onShow() {
    console.log('OperationLead: onShow()'); // eslint-disable-line no-console

    this.$router.push({
      name: 'Lead',
      params: { code: leadRouteCode(`${this.operationInfo?.id}`) },
      query: { tab: 'dashboard' },
    });
  }

  onClose() {
    console.log(`${this.constructor.name}: onClose()`); // eslint-disable-line no-console

    this.$emit('close');
  }
}
